/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLibraryUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h16.847l1.973 11.836-1.973.328L17.153 4H14.18l2.139 12.836-1.973.328L14 15.083V22H2zm10 2H9v2h3zM7 4H4v2h3zm0 4H4v8h3zm0 10H4v2h3zm2 2h3v-2H9zm3-4V8H9v8zm8-.414 3.707 3.707-1.414 1.414L21 19.414V23h-2v-3.586l-1.293 1.293-1.414-1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLibraryUp as LibraryUp };
